export const PIXELS_MENU_PLUS_QUIZ_HEADER = 150 as number;